<script>
import { apiSecond } from '@/boot/axios'
import SelectRegionList from '@/components/catalog/SelectRegionList.vue'
import SelectPool from '@/components/catalog/SelectPool.vue'
import writeXlsxFile from 'write-excel-file'
import GeneralTab from './GeneralTab.vue'
import PoolsTab from './PoolsTab.vue'

export default {
	name: 'DiagramAnalytics',
	components: {
		SelectRegionList,
		SelectPool,
		GeneralTab,
		PoolsTab,
	},
	data() {
		return {
			activeTab: 'general',
			loaded: false,
			errorMessage: { status: null, text: null },
			cacheState: {
				general: { loaded: false, key: '' },
				pools: { loaded: false, key: '' },
			},
			filters: {
				date_from: '',
				date_to: '',
				region_id: null,
				pool_id: null,
			},
			reportsFilters: {
				year: new Date().getFullYear(),
			},
			binFilters: {
				bin: '',
				date_from: '',
				date_to: '',
			},
			binValidationError: null,
			loadingStates: {
				users: false,
				quotas: false,
				reports: false,
				bin: false,
				fish: false,
				pools: false,
			},
			// Users analytics data
			usersSeries: [],
			totalUsers: 0,
			usersChartOptions: {
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 5,
						borderRadiusApplication: 'end',
					},
				},
				dataLabels: { enabled: false },
				stroke: { show: true, width: 2, colors: ['transparent'] },
				xaxis: { categories: [] },
				yaxis: { labels: { formatter: (val) => Number(val).toFixed(0) } },
				fill: { opacity: 1 },
				tooltip: {
					y: {
						formatter: (val) => Number(val).toFixed(0),
						title: { formatter: () => '' },
					},
				},
			},
			// Quotas analytics data
			quotasSeries: [],
			totalQuotas: 0,
			totalQuotasFishVolume: 0,
			quotasChartOptions: {
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 5,
						borderRadiusApplication: 'end',
						columnWidth: '70%',
					},
				},
				dataLabels: { enabled: false },
				stroke: { show: true, width: 2, colors: ['transparent'] },
				xaxis: { categories: [] },
				yaxis: [
					{
						title: {
							text: 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				fill: { opacity: 1 },
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () => 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => 'Объем рыбы',
							},
						},
					],
				},
				legend: {
					position: 'top',
					horizontalAlign: 'left',
				},
			},
			// Reports analytics data
			reportsSeries: [],
			totalReports: 0,
			reportsYear: null,
			reportsChartOptions: {
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 5,
						borderRadiusApplication: 'end',
					},
				},
				dataLabels: { enabled: false },
				stroke: { show: true, width: 2, colors: ['transparent'] },
				xaxis: { categories: [] },
				yaxis: { labels: { formatter: (val) => Number(val).toFixed(0) } },
				fill: { opacity: 1 },
				tooltip: {
					y: {
						formatter: (val) => Number(val).toFixed(0),
						title: { formatter: () => '' },
					},
				},
			},
			// BIN analytics data
			binSeries: [],
			totalBinTrades: 0,
			totalBinFishVolume: 0,
			binUser: null,
			binUserInfo: null, // Store user info from BIN check API
			// Fish analytics data
			fishSeries: [],
			totalFishTrades: 0,
			totalFishVolume: 0,
			fishUser: null,
			// Pool-distribution charts (3 diagrams)
			pools: [],
			usersByPoolSeries: [],
			usersByPoolOptions: {
				chart: { type: 'pie', height: 350, toolbar: { show: false } },
				labels: [],
				legend: { position: 'right' },
				tooltip: { y: { formatter: (val) => Number(val).toFixed(0) } },
			},
			tradesByPoolSeries: [],
			tradesByPoolOptions: {
				chart: { type: 'pie', height: 350, toolbar: { show: false } },
				labels: [],
				legend: { position: 'right' },
				tooltip: { y: { formatter: (val) => Number(val).toFixed(0) } },
			},
			fishVolumeByPoolSeries: [],
			fishVolumeByPoolOptions: {
				chart: { type: 'pie', height: 350, toolbar: { show: false } },
				labels: [],
				legend: { position: 'right' },
				tooltip: { y: { formatter: (val) => Number(val).toFixed(0) + ' кг' } },
			},
			binChartOptions: {
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 5,
						borderRadiusApplication: 'end',
						columnWidth: '70%',
					},
				},
				dataLabels: { enabled: false },
				stroke: { show: true, width: 2, colors: ['transparent'] },
				xaxis: { categories: [] },
				yaxis: [
					{
						title: {
							text: 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				fill: { opacity: 1 },
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () => 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => 'Объем рыбы',
							},
						},
					],
				},
				legend: {
					position: 'top',
					horizontalAlign: 'left',
				},
			},
			// Fish analytics chart options
			fishChartOptions: {
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				plotOptions: {
					bar: {
						horizontal: false,
						borderRadius: 5,
						borderRadiusApplication: 'end',
						columnWidth: '70%',
					},
				},
				dataLabels: { enabled: false },
				stroke: { show: true, width: 2, colors: ['transparent'] },
				xaxis: { categories: [] },
				yaxis: [
					{
						title: {
							text: 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				fill: { opacity: 1 },
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () => 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => 'Объем рыбы',
							},
						},
					],
				},
				legend: {
					position: 'top',
					horizontalAlign: 'left',
				},
			},
			binSearched: false,
		}
	},
	computed: {
		activeFilters() {
			const filters = []

			// Period filters
			if (this.filters.date_from || this.filters.date_to) {
				const dateRange = []
				if (this.filters.date_from) dateRange.push(this.filters.date_from)
				if (this.filters.date_to) dateRange.push(this.filters.date_to)
				filters.push(`${this.$t('filters.period')}: ${dateRange.join(' - ')}`)
			}

			// Region filter
			if (this.filters.region_id) {
				const regionName =
					this.filters.region_id.title ||
					this.filters.region_id.name ||
					this.$t('filters.unknown_region')
				filters.push(`${this.$t('filters.region')}: ${regionName}`)
			}

			// Pool filter
			if (this.filters.pool_id) {
				const poolName =
					this.filters.pool_id.title || this.filters.pool_id.name || this.$t('filters.unknown_pool')
				filters.push(`${this.$t('filters.pool')}: ${poolName}`)
			}

			// BIN filter (only show if in BIN mode and searched)
			if (this.isBinMode && this.binSearched) {
				const binText = `${this.$t('filters.bin') || 'БИН'}: ${this.binFilters.bin}`
				if (this.binUserInfo && this.binUserInfo.name_company) {
					filters.push(`${binText} (${this.binUserInfo.name_company})`)
				} else {
					filters.push(binText)
				}
			}

			return filters
		},
		isBinMode() {
			return !!this.binFilters.bin && !this.binValidationError
		},
		hasActiveFilters() {
			return this.activeFilters.length > 0
		},
	},
	mounted() {
		this.fetchActiveTabAnalytics()
	},
	methods: {
		createGeneralCacheKey() {
			const keyObj = {
				date_from: this.filters.date_from || '',
				date_to: this.filters.date_to || '',
				region_id: this.filters.region_id
					? this.filters.region_id.id || this.filters.region_id
					: '',
				pool_id: this.filters.pool_id ? this.filters.pool_id.id || this.filters.pool_id : '',
				bin: this.binFilters.bin || '',
				reports_year: this.reportsFilters.year || '',
			}
			return JSON.stringify(keyObj)
		},
		createPoolsCacheKey() {
			const keyObj = {
				date_from: this.filters.date_from || '',
				date_to: this.filters.date_to || '',
			}
			return JSON.stringify(keyObj)
		},
		invalidateGeneralCache() {
			this.cacheState.general = { loaded: false, key: '' }
		},
		invalidatePoolsCache() {
			this.cacheState.pools = { loaded: false, key: '' }
		},
		switchTab(tab) {
			if (this.activeTab === tab) return
			this.activeTab = tab
			this.fetchActiveTabAnalytics()
		},
		async fetchActiveTabAnalytics() {
			if (this.activeTab === 'general') {
				await this.fetchGeneralAnalytics()
			} else if (this.activeTab === 'pools') {
				await this.fetchPoolsAndBuildDiagrams()
			}
		},
		async fetchGeneralAnalytics() {
			const key = this.createGeneralCacheKey()
			if (this.cacheState.general.loaded && this.cacheState.general.key === key) {
				return
			}
			this.loaded = false
			this.errorMessage = { status: null, text: null }
			try {
				await Promise.all([
					this.fetchUsersAndQuotasAnalytics(),
					this.fetchReportsAnalytics(),
					this.fetchFishAnalytics(),
				])
				this.cacheState.general = { loaded: true, key }
			} catch (error) {
				this.usersSeries = []
				this.quotasSeries = []
				this.reportsSeries = []
				this.fishSeries = []
				this.usersChartOptions = { ...this.usersChartOptions, xaxis: { categories: [] } }
				this.quotasChartOptions = { ...this.quotasChartOptions, xaxis: { categories: [] } }
				this.reportsChartOptions = { ...this.reportsChartOptions, xaxis: { categories: [] } }
				this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
				this.errorMessage = {
					status: error?.response?.status || null,
					text:
						error?.response?.data?.message ||
						(this.$t && this.$t('messages.load_error')) ||
						'Ошибка загрузки',
				}
			} finally {
				this.loaded = true
			}
		},
		async fetchAnalytics() {
			this.loaded = false
			this.errorMessage = { status: null, text: null }
			try {
				// Deprecated in favor of fetchActiveTabAnalytics
				await this.fetchActiveTabAnalytics()
			} catch (error) {
				this.usersSeries = []
				this.quotasSeries = []
				this.reportsSeries = []
				this.fishSeries = []
				this.usersChartOptions = { ...this.usersChartOptions, xaxis: { categories: [] } }
				this.quotasChartOptions = { ...this.quotasChartOptions, xaxis: { categories: [] } }
				this.reportsChartOptions = { ...this.reportsChartOptions, xaxis: { categories: [] } }
				this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
				this.errorMessage = {
					status: error?.response?.status || null,
					text:
						error?.response?.data?.message ||
						(this.$t && this.$t('messages.load_error')) ||
						'Ошибка загрузки',
				}
			} finally {
				this.loaded = true
			}
		},
		async fetchPoolsAndBuildDiagrams() {
			const key = this.createPoolsCacheKey()
			if (this.cacheState.pools.loaded && this.cacheState.pools.key === key) {
				return
			}
			this.loadingStates.pools = true
			try {
				// 1) Load pools
				const poolsResp = await apiSecond.get('/v2/handbook-pools')
				const poolsData = Array.isArray(poolsResp.data?.data) ? poolsResp.data.data : []
				this.pools = poolsData.map((p) => ({ id: p.id, title: p.title }))

				// 2) For each pool call both users and trades endpoints (8 pools x 2 APIs)
				const usersPromises = []
				const tradesPromises = []
				for (const pool of this.pools) {
					const baseParams = { pool_id: pool.id }
					// Only date filter should work for Pools tab
					if (this.filters.date_from) baseParams.date_from = this.filters.date_from
					if (this.filters.date_to) baseParams.date_to = this.filters.date_to
					usersPromises.push(apiSecond.get('/v1/period-analytics/users', { params: baseParams }))
					tradesPromises.push(apiSecond.get('/v1/period-analytics/trades', { params: baseParams }))
				}

				const usersResponses = await Promise.all(usersPromises)
				const tradesResponses = await Promise.all(tradesPromises)

				// 3) Aggregate per pool totals (keep order by this.pools)
				const usersByPool = this.pools.map((pool, idx) => {
					const items = Array.isArray(usersResponses[idx]?.data?.data)
						? usersResponses[idx].data.data
						: []
					const value = items.reduce((sum, i) => sum + Number(i.total_users || 0), 0)
					return { label: pool.title, value }
				})
				const tradesByPool = this.pools.map((pool, idx) => {
					const items = Array.isArray(tradesResponses[idx]?.data?.data)
						? tradesResponses[idx].data.data
						: []
					const value = items.reduce((sum, i) => sum + Number(i.total_trades || 0), 0)
					return { label: pool.title, value }
				})
				const volumeByPool = this.pools.map((pool, idx) => {
					const items = Array.isArray(tradesResponses[idx]?.data?.data)
						? tradesResponses[idx].data.data
						: []
					const value = items.reduce((sum, i) => sum + Number(i.total_fish_volume || 0), 0)
					return { label: pool.title, value }
				})

				// 4) Apply to charts
				this.usersByPoolSeries = usersByPool.map((x) => x.value)
				this.usersByPoolOptions = {
					...this.usersByPoolOptions,
					labels: usersByPool.map((x) => x.label),
				}
				this.tradesByPoolSeries = tradesByPool.map((x) => x.value)
				this.tradesByPoolOptions = {
					...this.tradesByPoolOptions,
					labels: tradesByPool.map((x) => x.label),
				}
				this.fishVolumeByPoolSeries = volumeByPool.map((x) => x.value)
				this.fishVolumeByPoolOptions = {
					...this.fishVolumeByPoolOptions,
					labels: volumeByPool.map((x) => x.label),
				}
				this.cacheState.pools = { loaded: true, key }
			} catch (error) {
				this.usersByPoolSeries = []
				this.tradesByPoolSeries = []
				this.fishVolumeByPoolSeries = []
				console.error('Error fetching pools analytics:', error)
			} finally {
				this.loadingStates.pools = false
			}
		},
		applyUsersChartData(items) {
			const categories = items.map((i) => i.month)
			const values = items.map((i) => Number(i.total_users || 0))
			this.usersSeries = [
				{ name: (this.$t && this.$t('titles.total_users')) || 'Всего пользователей', data: values },
			]
			this.totalUsers = values.reduce((sum, v) => sum + v, 0)
			this.usersChartOptions = { ...this.usersChartOptions, xaxis: { categories } }
		},
		applyQuotasChartData(items) {
			const categories = items.map((i) => i.month)
			const quotasValues = items.map((i) => Number(i.total_trades || 0))
			const fishVolumeValues = items.map((i) => Number(i.total_fish_volume || 0))

			this.quotasSeries = [
				{ name: (this.$t && this.$t('titles.total_trades')) || 'Всего квот', data: quotasValues },
				{
					name: (this.$t && this.$t('titles.total_fish_volume')) || 'Объем рыбы (кг)',
					data: fishVolumeValues,
				},
			]
			this.totalQuotas = quotasValues.reduce((sum, v) => sum + v, 0)
			this.totalQuotasFishVolume = fishVolumeValues.reduce((sum, v) => sum + v, 0)
			this.quotasChartOptions = {
				...this.quotasChartOptions,
				xaxis: { categories },
				yaxis: [
					{
						title: {
							text: this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () =>
									this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => this.$t('titles.total_fish_volume') || 'Объем рыбы',
							},
						},
					],
				},
			}
		},
		applyReportsChartData(items, year) {
			const categories = items.map((i) => i.quarter)
			const values = items.map((i) => Number(i.total_reports || 0))

			this.reportsSeries = [
				{ name: (this.$t && this.$t('titles.total_reports')) || 'Всего отчетов', data: values },
			]
			this.totalReports = values.reduce((sum, v) => sum + v, 0)
			this.reportsYear = year
			this.reportsChartOptions = { ...this.reportsChartOptions, xaxis: { categories } }
		},
		applyBinChartData(items, user) {
			const categories = items.map((i) => i.month)
			const tradesValues = items.map((i) => Number(i.total_trades || 0))
			const fishVolumeValues = items.map((i) => Number(i.total_fish_volume || 0))

			this.binSeries = [
				{ name: (this.$t && this.$t('titles.total_trades')) || 'Всего квот', data: tradesValues },
				{
					name: (this.$t && this.$t('titles.total_fish_volume')) || 'Объем рыбы (кг)',
					data: fishVolumeValues,
				},
			]
			this.totalBinTrades = tradesValues.reduce((sum, v) => sum + v, 0)
			this.totalBinFishVolume = fishVolumeValues.reduce((sum, v) => sum + v, 0)
			this.binUser = user
			this.binChartOptions = {
				...this.binChartOptions,
				xaxis: { categories },
				yaxis: [
					{
						title: {
							text: this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () =>
									this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => this.$t('titles.total_fish_volume') || 'Объем рыбы',
							},
						},
					],
				},
			}
		},
		applyFishChartData(items, user) {
			// Handle empty data
			if (!Array.isArray(items) || items.length === 0) {
				this.fishSeries = []
				this.totalFishTrades = 0
				this.totalFishVolume = 0
				this.fishUser = user
				this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
				return
			}

			const categories = items.map((i) => i.fish_name)
			const tradesValues = items.map((i) => Number(i.total_trades || 0))
			const fishVolumeValues = items.map((i) => Number(i.total_volume || 0))

			this.fishSeries = [
				{
					name: (this.$t && this.$t('titles.total_trades')) || 'Всего записей',
					data: tradesValues,
				},
				{
					name: (this.$t && this.$t('titles.total_fish_volume')) || 'Объем рыбы (кг)',
					data: fishVolumeValues,
				},
			]
			this.totalFishTrades = tradesValues.reduce((sum, v) => sum + v, 0)
			this.totalFishVolume = fishVolumeValues.reduce((sum, v) => sum + v, 0)
			this.fishUser = user
			this.fishChartOptions = {
				...this.fishChartOptions,
				xaxis: { categories },
				yaxis: [
					{
						title: {
							text: this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) },
					},
					{
						opposite: true,
						title: {
							text: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)',
						},
						labels: { formatter: (val) => Number(val).toFixed(0) + ' кг' },
					},
				],
				tooltip: {
					y: [
						{
							formatter: (val) => Number(val).toFixed(0),
							title: {
								formatter: () =>
									this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
							},
						},
						{
							formatter: (val) => Number(val).toFixed(0) + ' кг',
							title: {
								formatter: () => this.$t('titles.total_fish_volume') || 'Объем рыбы',
							},
						},
					],
				},
			}
		},
		async search() {
			if (this.isBinMode) {
				this.binSearched = true
				this.invalidateGeneralCache()
				await this.searchBin()
				return
			}
			this.binSearched = false
			// Call APIs only for active tab
			if (this.activeTab === 'general') {
				this.invalidateGeneralCache()
				await Promise.all([this.fetchUsersAndQuotasAnalytics(), this.fetchFishAnalytics()])
			} else if (this.activeTab === 'pools') {
				this.invalidatePoolsCache()
				await this.fetchPoolsAndBuildDiagrams()
			}
		},
		clearFilters() {
			this.filters.date_from = ''
			this.filters.date_to = ''
			this.filters.region_id = null
			this.filters.pool_id = null
			this.binFilters.bin = ''
			this.binValidationError = null
			this.binSearched = false
			this.search()
			this.fetchPoolsAndBuildDiagrams()
		},
		async searchReports() {
			await this.fetchReportsAnalytics()
		},
		clearReportsFilters() {
			this.reportsFilters.year = new Date().getFullYear()
			this.searchReports()
		},
		validateBin() {
			const bin = this.binFilters.bin
			if (!bin) {
				this.binValidationError = null
				return
			}

			// Check if BIN contains only digits
			if (!/^\d+$/.test(bin)) {
				this.binValidationError =
					this.$t('validation.bin_digits_only') || 'БИН должен содержать только цифры'
				return
			}

			// Check if BIN has exactly 12 digits
			if (bin.length !== 12) {
				this.binValidationError = this.$t('validation.bin_length') || 'БИН должен содержать 12 цифр'
				return
			}

			this.binValidationError = null
		},
		async searchBin() {
			if (!this.binFilters.bin) {
				return
			}

			// Validate BIN before search
			this.validateBin()
			if (this.binValidationError) {
				return
			}

			// Set loading states
			this.loadingStates.bin = true
			this.loadingStates.fish = true

			try {
				// Fetch user info, BIN analytics, and fish analytics in parallel
				await Promise.all([
					this.fetchBinUserInfo(),
					this.fetchBinAnalytics(),
					this.fetchFishAnalytics(),
				])
			} catch (error) {
				console.error('Error in searchBin:', error)
			} finally {
				this.loadingStates.bin = false
				this.loadingStates.fish = false
			}
		},
		clearBinFilters() {
			this.binFilters.bin = ''
			this.binFilters.date_from = ''
			this.binFilters.date_to = ''
			this.binValidationError = null
			this.binSeries = []
			this.totalBinTrades = 0
			this.totalBinFishVolume = 0
			this.binUser = null
			this.binUserInfo = null
			this.binChartOptions = { ...this.binChartOptions, xaxis: { categories: [] } }
			this.fishSeries = []
			this.totalFishTrades = 0
			this.totalFishVolume = 0
			this.fishUser = null
			this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
		},
		clearFilter(filterType) {
			switch (filterType) {
				case 'period':
					this.filters.date_from = ''
					this.filters.date_to = ''
					break
				case 'region':
					this.filters.region_id = null
					break
				case 'pool':
					this.filters.pool_id = null
					break
				case 'bin':
					this.binFilters.bin = ''
					this.binValidationError = null
					this.binSearched = false
					this.binSeries = []
					this.totalBinTrades = 0
					this.totalBinFishVolume = 0
					this.binUser = null
					this.binUserInfo = null
					this.binChartOptions = { ...this.binChartOptions, xaxis: { categories: [] } }
					this.fishSeries = []
					this.totalFishTrades = 0
					this.totalFishVolume = 0
					this.fishUser = null
					this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
					break
			}
			// Refresh data after clearing filter
			this.search()
			this.fetchPoolsAndBuildDiagrams()
		},
		getFilterType(filterText) {
			if (filterText.includes(this.$t('filters.period'))) return 'period'
			if (filterText.includes(this.$t('filters.region'))) return 'region'
			if (filterText.includes(this.$t('filters.pool'))) return 'pool'
			if (filterText.includes(this.$t('filters.bin') || 'БИН')) return 'bin'
			return null
		},
		async fetchUsersAndQuotasAnalytics() {
			this.loadingStates.users = true
			this.loadingStates.quotas = true
			try {
				const params = {}
				if (this.filters.region_id)
					params.region_id = this.filters.region_id.id || this.filters.region_id
				if (this.filters.pool_id) params.pool_id = this.filters.pool_id.id || this.filters.pool_id

				// Fetch only users and quotas APIs
				const [usersResponse, quotasResponse] = await Promise.all([
					apiSecond.get('/v1/period-analytics/users', { params }),
					apiSecond.get('/v1/period-analytics/trades', { params }),
				])

				// Process users data
				const usersList = Array.isArray(usersResponse.data?.data) ? usersResponse.data.data : []
				this.applyUsersChartData(usersList)

				// Process quotas data
				const quotasList = Array.isArray(quotasResponse.data?.data) ? quotasResponse.data.data : []
				this.applyQuotasChartData(quotasList)
			} catch (error) {
				this.usersSeries = []
				this.quotasSeries = []
				this.usersChartOptions = { ...this.usersChartOptions, xaxis: { categories: [] } }
				this.quotasChartOptions = { ...this.quotasChartOptions, xaxis: { categories: [] } }
				console.error('Error fetching users and quotas analytics:', error)
			} finally {
				this.loadingStates.users = false
				this.loadingStates.quotas = false
			}
		},
		async fetchReportsAnalytics() {
			this.loadingStates.reports = true
			try {
				const reportsParams = { year: this.reportsFilters.year }
				const reportsResponse = await apiSecond.get('/v1/period-analytics/reports/1', {
					params: reportsParams,
				})

				// Process reports data
				const reportsData = reportsResponse.data?.data || []
				this.applyReportsChartData(reportsData, reportsResponse.data?.year)
			} catch (error) {
				this.reportsSeries = []
				this.reportsChartOptions = { ...this.reportsChartOptions, xaxis: { categories: [] } }
				console.error('Error fetching reports analytics:', error)
			} finally {
				this.loadingStates.reports = false
			}
		},
		async fetchBinUserInfo() {
			try {
				const response = await apiSecond.get('/v1/virtual-store/check-bin', {
					params: { iin_bin: this.binFilters.bin },
				})
				this.binUserInfo = response.data?.data || null
			} catch (error) {
				this.binUserInfo = null
				console.error('Error fetching BIN user info:', error)
			}
		},
		async fetchBinAnalytics() {
			try {
				const params = { bin: this.binFilters.bin }
				const binResponse = await apiSecond.get('/v1/period-analytics/from-bin', {
					params,
				})
				const binData = binResponse.data?.data || []
				const binUser = binResponse.data?.user || null
				this.applyBinChartData(binData, binUser)
			} catch (error) {
				this.binSeries = []
				this.binChartOptions = { ...this.binChartOptions, xaxis: { categories: [] } }
				this.binUser = null
				console.error('Error fetching BIN analytics:', error)
			}
		},
		async fetchFishAnalytics() {
			try {
				const params = {}

				// Add BIN filter if provided
				if (this.binFilters.bin) {
					params.bin = this.binFilters.bin
				}

				// Add region and pool filters
				if (this.filters.region_id) {
					params.region_id = this.filters.region_id.id || this.filters.region_id
				}
				if (this.filters.pool_id) {
					params.pool_id = this.filters.pool_id.id || this.filters.pool_id
				}

				const fishResponse = await apiSecond.get('/v1/period-analytics/user-fish', {
					params,
				})

				// Handle new API response structure
				const responseData = fishResponse.data || {}
				const fishData = Array.isArray(responseData.data) ? responseData.data : []

				// Apply chart data with the new structure
				this.applyFishChartData(fishData, null)
			} catch (error) {
				this.fishSeries = []
				this.fishChartOptions = { ...this.fishChartOptions, xaxis: { categories: [] } }
				this.fishUser = null
				console.error('Error fetching fish analytics:', error)
			}
		},
		async downloadExcel() {
			try {
				// Collect all chart data into a single sheet
				const excelData = []

				// Add title
				excelData.push([
					{
						value: this.$t('titles.diagram_analytics') || 'Аналитика диаграмм',
						fontWeight: 'bold',
					},
				])
				excelData.push([{ value: '' }]) // Empty row

				// Add filters information at the top (if any)
				if (this.hasActiveFilters || this.isBinMode) {
					excelData.push([
						{
							value: this.$t('titles.filters_applied') || 'Примененные фильтры',
							fontWeight: 'bold',
						},
					])
					this.activeFilters.forEach((filter) => {
						excelData.push([{ value: filter }])
					})

					if (this.isBinMode && this.binUserInfo) {
						excelData.push([{ value: '' }])
						excelData.push([
							{
								value: this.$t('titles.bin_user_info') || 'Информация о пользователе',
								fontWeight: 'bold',
							},
						])
						excelData.push([
							{ value: this.$t('titles.bin') || 'БИН', fontWeight: 'bold' },
							{ value: this.binUserInfo.iin_bin },
						])
						if (this.binUserInfo.name_company) {
							excelData.push([
								{
									value: this.$t('titles.company_name') || 'Название компании',
									fontWeight: 'bold',
								},
								{ value: this.binUserInfo.name_company },
							])
						}
						if (this.binUserInfo.first_name || this.binUserInfo.last_name) {
							const fullName = [
								this.binUserInfo.first_name,
								this.binUserInfo.last_name,
								this.binUserInfo.middle_name,
							]
								.filter(Boolean)
								.join(' ')
							excelData.push([
								{ value: this.$t('titles.name') || 'Имя', fontWeight: 'bold' },
								{ value: fullName },
							])
						}
					}
					excelData.push([{ value: '' }]) // Empty row
				}

				// Users Analytics Data
				if (this.usersSeries && this.usersSeries.length > 0) {
					excelData.push([
						{
							value: this.$t('titles.users_analytics') || 'Статистика регистрации субъектов',
							fontWeight: 'bold',
						},
					])
					excelData.push([
						{ value: this.$t('titles.month') || 'Месяц', fontWeight: 'bold' },
						{ value: this.$t('titles.total_users') || 'Всего пользователей', fontWeight: 'bold' },
					])
					this.usersChartOptions.xaxis.categories.forEach((month, index) => {
						excelData.push([{ value: month }, { value: this.usersSeries[0].data[index] || 0 }])
					})
					excelData.push([
						{ value: this.$t('headers.total') || 'Итого', fontWeight: 'bold' },
						{ value: this.totalUsers, fontWeight: 'bold' },
					])
					excelData.push([{ value: '' }]) // Empty row
				}

				// Quotas Analytics Data
				if (this.quotasSeries && this.quotasSeries.length > 0) {
					excelData.push([
						{
							value: this.$t('titles.quotas_analytics') || 'Статистика объемов выловленной рыбы',
							fontWeight: 'bold',
						},
					])
					excelData.push([
						{ value: this.$t('titles.month') || 'Месяц', fontWeight: 'bold' },
						{
							value: this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
							fontWeight: 'bold',
						},
						{ value: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)', fontWeight: 'bold' },
					])
					this.quotasChartOptions.xaxis.categories.forEach((month, index) => {
						excelData.push([
							{ value: month },
							{ value: this.quotasSeries[0].data[index] || 0 },
							{ value: this.quotasSeries[1].data[index] || 0 },
						])
					})
					excelData.push([
						{ value: this.$t('headers.total') || 'Итого', fontWeight: 'bold' },
						{ value: this.totalQuotas, fontWeight: 'bold' },
						{ value: this.totalQuotasFishVolume, fontWeight: 'bold' },
					])
					excelData.push([{ value: '' }]) // Empty row
				}

				// Fish Analytics Data
				if (this.fishSeries && this.fishSeries.length > 0) {
					excelData.push([
						{
							value: this.$t('titles.fish_analytics') || 'Аналитика по видам рыб',
							fontWeight: 'bold',
						},
					])
					excelData.push([
						{ value: this.$t('titles.fish_name') || 'Название рыбы', fontWeight: 'bold' },
						{ value: this.$t('titles.total_trades') || 'Всего записей', fontWeight: 'bold' },
						{ value: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)', fontWeight: 'bold' },
					])
					this.fishChartOptions.xaxis.categories.forEach((fishName, index) => {
						excelData.push([
							{ value: fishName },
							{ value: this.fishSeries[0].data[index] || 0 },
							{ value: this.fishSeries[1].data[index] || 0 },
						])
					})
					excelData.push([
						{ value: this.$t('headers.total') || 'Итого', fontWeight: 'bold' },
						{ value: this.totalFishTrades, fontWeight: 'bold' },
						{ value: this.totalFishVolume, fontWeight: 'bold' },
					])
					excelData.push([{ value: '' }]) // Empty row
				}

				// Reports Analytics Data
				if (this.reportsSeries && this.reportsSeries.length > 0) {
					excelData.push([
						{
							value: this.$t('titles.reports_analytics') || 'Аналитика 1рх отчётов',
							fontWeight: 'bold',
						},
					])
					excelData.push([
						{ value: this.$t('titles.quarter') || 'Квартал', fontWeight: 'bold' },
						{ value: this.$t('titles.total_reports') || 'Всего отчетов', fontWeight: 'bold' },
					])
					this.reportsChartOptions.xaxis.categories.forEach((quarter, index) => {
						excelData.push([{ value: quarter }, { value: this.reportsSeries[0].data[index] || 0 }])
					})
					excelData.push([
						{ value: this.$t('headers.total') || 'Итого', fontWeight: 'bold' },
						{ value: this.totalReports, fontWeight: 'bold' },
					])
					excelData.push([{ value: '' }]) // Empty row
				}

				// BIN Analytics Data (if in BIN mode)
				if (this.isBinMode && this.binSearched && this.binSeries && this.binSeries.length > 0) {
					excelData.push([
						{ value: this.$t('titles.bin_analytics') || 'Аналитика по БИН', fontWeight: 'bold' },
					])
					excelData.push([
						{ value: this.$t('titles.month') || 'Месяц', fontWeight: 'bold' },
						{
							value: this.$t('titles.total_trades') || 'Всего записей в промысловый журнал',
							fontWeight: 'bold',
						},
						{ value: this.$t('titles.total_fish_volume') || 'Объем рыбы (кг)', fontWeight: 'bold' },
					])
					this.binChartOptions.xaxis.categories.forEach((month, index) => {
						excelData.push([
							{ value: month },
							{ value: this.binSeries[0].data[index] || 0 },
							{ value: this.binSeries[1].data[index] || 0 },
						])
					})
					excelData.push([
						{ value: this.$t('headers.total') || 'Итого', fontWeight: 'bold' },
						{ value: this.totalBinTrades, fontWeight: 'bold' },
						{ value: this.totalBinFishVolume, fontWeight: 'bold' },
					])
					excelData.push([{ value: '' }]) // Empty row
				}

				// Generate filename with current date and filters info
				const currentDate = new Date().toISOString().split('T')[0]
				let filename = `analytics_${currentDate}`

				if (this.isBinMode && this.binUserInfo) {
					filename += `_bin_${this.binUserInfo.iin_bin}`
				}

				// Create Excel file
				await writeXlsxFile(excelData, {
					fileName: `${filename}.xlsx`,
				})
			} catch (error) {
				console.error('Error generating Excel file:', error)
				// You can add a toast notification here if available
				this.$dialog.alert(this.$t('messages.excel_download_error'))
			}
		},
	},
}
</script>

<template>
	<div class="wrap__content" v-bind:class="{ 'wrap__content--preloader': !loaded }">
		<v-preloader v-if="!loaded" :message="errorMessage"></v-preloader>
		<div class="container" v-if="loaded">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['DiagramAnalytics']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">{{ $t('titles.diagram_analytics') }}</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="table__block--filter">
										<div class="w-full row gap-y-2">
											<div class="col-12 col-md-6 col-lg-3">
												<label class="search__label">
													<span class="mr-2">{{ $t('filters.date_from') }}</span>
													<input
														v-model="filters.date_from"
														type="date"
														name="filter_date_from"
														class="input-linck filter-input"
													/>
												</label>
											</div>
											<div class="col-12 col-md-6 col-lg-3">
												<label class="search__label">
													<span class="mr-2">{{ $t('filters.date_to') }}</span>
													<input
														v-model="filters.date_to"
														type="date"
														name="filter_date_to"
														class="input-linck filter-input"
													/>
												</label>
											</div>
											<div class="col-12 col-md-6 col-lg-3">
												<SelectRegionList
													:value="filters.region_id"
													:with-title="false"
													:multiple="false"
													:placeholder="$t('filters.search_by_region')"
													@input="filters.region_id = $event"
												/>
											</div>
											<div class="col-12 col-md-6 col-lg-3">
												<SelectPool
													:value="filters.pool_id"
													:with-title="false"
													:multiple="false"
													:placeholder="$t('filters.select_pond')"
													@input="filters.pool_id = $event"
												/>
											</div>
											<div class="col-12 col-md-6 col-lg-3">
												<label class="search__label">
													<span class="mr-2">{{ $t('filters.bin') || 'БИН' }}</span>
													<input
														v-model="binFilters.bin"
														type="text"
														name="filter_bin_top"
														class="input-linck filter-input"
														:class="{ error: binValidationError }"
														:placeholder="$t('filters.enter_bin') || 'Введите БИН'"
														maxlength="12"
														@input="validateBin"
													/>
													<div v-if="binValidationError" class="text-red-500 text-xs mt-1">
														{{ binValidationError }}
													</div>
												</label>
											</div>
											<div class="col flex items-end gap-2">
												<button class="input-btn form__line--btn" @click="search">
													{{ $t('button.find') }}
												</button>
												<button class="btn--link btn--link--plus" @click="clearFilters">
													{{ $t('button.clear') }}
												</button>
												<button
													class="input-btn form__line--btn btn--excel"
													@click="downloadExcel"
													:disabled="!loaded"
													:title="$t('button.download_excel') || 'Скачать Excel'"
												>
													<svg class="btn--excel-icon" fill="currentColor" viewBox="0 0 20 20">
														<path
															fill-rule="evenodd"
															d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
															clip-rule="evenodd"
														></path>
													</svg>
													{{ $t('button.download_excel') || 'Скачать Excel' }}
												</button>
											</div>
										</div>
									</div>

									<!-- Tabs Header -->
									<div class="tabs mb-6">
										<button
											class="tab"
											:class="{ active: activeTab === 'general' }"
											@click="switchTab('general')"
										>
											{{ $t('titles.general_analytics') || 'Общая аналитика' }}
										</button>
										<button
											class="tab"
											:class="{ active: activeTab === 'pools' }"
											@click="switchTab('pools')"
										>
											{{ $t('titles.pools_distribution') || 'Распределение по бассейнам' }}
										</button>
									</div>

									<!-- Tabs Content -->
									<GeneralTab
										v-if="activeTab === 'general'"
										:hasActiveFilters="hasActiveFilters"
										:activeFilters="activeFilters"
										:loadingUsers="loadingStates.users"
										:usersSeries="usersSeries"
										:usersChartOptions="usersChartOptions"
										:totalUsers="totalUsers"
										:loadingQuotas="loadingStates.quotas"
										:quotasSeries="quotasSeries"
										:quotasChartOptions="quotasChartOptions"
										:totalQuotas="totalQuotas"
										:totalQuotasFishVolume="totalQuotasFishVolume"
										:loadingFish="loadingStates.fish"
										:fishSeries="fishSeries"
										:fishChartOptions="fishChartOptions"
										:totalFishTrades="totalFishTrades"
										:totalFishVolume="totalFishVolume"
										:loadingReports="loadingStates.reports"
										:reportsSeries="reportsSeries"
										:reportsChartOptions="reportsChartOptions"
										:reportsYear="reportsYear"
										:reportsFilters="reportsFilters"
										:isBinMode="isBinMode"
										:binSearched="binSearched"
										:loadingBin="loadingStates.bin"
										:binSeries="binSeries"
										:binChartOptions="binChartOptions"
										:binUser="binUser"
										:binUserInfo="binUserInfo"
										:onSearchReports="searchReports"
										:onClearReportsFilters="clearReportsFilters"
										:onClearFilter="clearFilter"
										:getFilterType="getFilterType"
									/>

									<PoolsTab
										v-else
										:hasActiveFilters="hasActiveFilters"
										:activeFilters="activeFilters"
										:isBinMode="isBinMode"
										:binSearched="binSearched"
										:loadingPools="loadingStates.pools"
										:usersByPoolSeries="usersByPoolSeries"
										:usersByPoolOptions="usersByPoolOptions"
										:tradesByPoolSeries="tradesByPoolSeries"
										:tradesByPoolOptions="tradesByPoolOptions"
										:fishVolumeByPoolSeries="fishVolumeByPoolSeries"
										:fishVolumeByPoolOptions="fishVolumeByPoolOptions"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.filter-input {
	border: 1px solid #d3e7fb;
	border-radius: 4px;
	padding: 8px 12px;
	transition: border-color 0.2s ease;
}

.filter-input:focus {
	outline: none;
	border-color: #157fee;
	box-shadow: 0 0 0 2px rgba(82, 165, 252, 0.1);
}

.filter-input:hover {
	border-color: #157fee;
}

.input-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
	background-color: #f5f5f5;
	color: #999;
}

.filter-input.error {
	border-color: #ef4444;
	box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);
}

.btn--excel {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 14px 16px;
	background-color: #10b981;
	color: white;
	border: 1px solid #10b981;
	border-radius: 24px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	text-decoration: none;
	margin-left: 8px;
}

.btn--excel:hover:not(:disabled) {
	background-color: #059669;
	border-color: #059669;
}

.btn--excel:active:not(:disabled) {
	background-color: #047857;
	border-color: #047857;
}

.btn--excel:disabled {
	opacity: 0.6;
	cursor: not-allowed;
	background-color: #9ca3af;
	border-color: #9ca3af;
}

.btn--excel-icon {
	width: 16px;
	height: 16px;
	flex-shrink: 0;
}

/* Tabs */
.tabs {
	display: flex;
	gap: 8px;
	border-bottom: 1px solid #d3e7fb;
	padding-bottom: 4px;
}

.tab {
	background: transparent;
	border: none;
	border-bottom: 2px solid transparent;
	color: #4b5563; /* text-normal */
	font-family: inherit;
	font-size: 14px;
	font-weight: 500;
	padding: 10px 12px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	cursor: pointer;
	transition: color 0.2s ease, border-color 0.2s ease;
}

.tab:hover {
	color: #1f2937;
	border-bottom-color: #cfe5fb;
	background-color: #f3f9ff;
}

.tab.active {
	color: #0b77d1; /* text-main */
	border-bottom-color: #157fee;
	background-color: #eaf4ff;
}
</style>
